import { Component, OnInit } from '@angular/core';
import { FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatLabel } from '@angular/material/form-field';
import { TranslatePipe } from '@ngx-translate/core';
import { CollaborationOperationsService } from '../../../../services/common/collaboration-operations.service';
import { IReqEditorAccessFormGroup } from '../../../../models/collaboration/IReqEditorAccessFormGroup';

@Component({
  selector: 'app-req-editor-access-dialog',
  imports: [TranslatePipe,
    MatButtonModule,
    MatLabel,
    MatCardModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,],
  templateUrl: './req-editor-access-dialog.component.html',
  styleUrl: './req-editor-access-dialog.component.scss'
})
export class ReqEditorAccessDialogComponent implements OnInit {

  readonly checked: boolean = false;
  reqEditorAccessFormGroup: FormGroup<IReqEditorAccessFormGroup>;

  constructor(public dialogRef: MatDialogRef<ReqEditorAccessDialogComponent>,
    private readonly collaborationOperationService: CollaborationOperationsService,
    private readonly fb: NonNullableFormBuilder) { }

  ngOnInit() {
    this.reqEditorAccessFormGroup = this.fb.group<IReqEditorAccessFormGroup>({
      changeLogNotes: this.fb.control(''),
      sendEmail: this.fb.control(false)
    });
  }

  get canRequestAccess() {
    return this.reqEditorAccessFormGroup.controls.changeLogNotes.value.trim().length > 0;
  }

  async requestAccess() {
    if(this.canRequestAccess){
      const result =await this.collaborationOperationService.requestAccess(
        this.reqEditorAccessFormGroup.controls.changeLogNotes.value.trim(),
        this.reqEditorAccessFormGroup.controls.sendEmail.value
      );
      if(result){
        this.dialogRef.close(true);
      }
    }
  }
}
